import { render, staticRenderFns } from "./topUserV2.vue?vue&type=template&id=5db43afd"
import script from "./topUserV2.vue?vue&type=script&lang=js"
export * from "./topUserV2.vue?vue&type=script&lang=js"
import style0 from "./topUserV2.vue?vue&type=style&index=0&id=5db43afd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports